import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ToastProvider } from '@core';
import { InvestigationsApi } from '../../../infrastructure/api/investigations.api';
import { InvestigationApprovalRequestEntity } from '../../../domain/entities/investigation-approval-request.entity';
import type { GetInvestigationApprovalRequestsQuery } from './get-investigation-approval-requests.query';
import type { GetInvestigationApprovalRequestsResult } from './get-investigation-approval-requests.result';

@Injectable({ providedIn: 'root' })
export class GetInvestigationApprovalRequestsUseCase {
  private readonly _api = inject(InvestigationsApi);
  private readonly _toast = inject(ToastProvider);

  public execute(query: GetInvestigationApprovalRequestsQuery): Observable<GetInvestigationApprovalRequestsResult> {
    return this._api.getApprovalRequests(query.investigationId).pipe(
      map((dtos) => {
        const requests = dtos.map((dto) => {
          const entity = new InvestigationApprovalRequestEntity();
          entity.id = dto.id;
          entity.workflowStepId = dto.workflowStepId;
          entity.workflowStepName = dto.workflowStepName;
          entity.approverUserId = dto.approverUserId;
          entity.approverName = dto.approverName;
          entity.approverRole = dto.approverRole;
          entity.decision = dto.decision;
          entity.decidedAt = dto.decidedAt;
          entity.denialNotes = dto.denialNotes;
          entity.canActNow = dto.canActNow;
          entity.isClosureApproval = dto.isClosureApproval ?? false;
          return entity;
        });
        return { requests };
      }),
      catchError((error) => {
        this._toast.error(
          'Failed to load approval requests',
          'Please try again or contact support.',
        );
        return throwError(() => error);
      }),
    );
  }
}
